import { motion } from "framer-motion";
import {
    Sofa,
    Armchair,
    BedDouble,
    Layers,
    SprayCan,
    Droplets,
    Car,
    Armchair as ChairIcon,
    ArrowUpRight,
} from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { SERVICES, whatsappLink, IMAGES } from "@/data";

const ICONS = {
    Sofa,
    Armchair,
    BedDouble,
    Layers,
    SprayCan,
    Droplets,
    Car,
    Chair: ChairIcon,
};

const gridClass = (i) => {
    if (i === 0) return "lg:col-span-2 lg:row-span-2 min-h-[320px]";
    if (i === 5) return "lg:col-span-2";
    return "";
};

export const Services = () => (
    <section
        id="servicos"
        data-testid="services-section"
        className="bg-navy noise-bg py-24 lg:py-32 relative overflow-hidden"
    >
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
                <Reveal>
                    <SectionLabel light>Nossos serviços</SectionLabel>
                    <h2 className="mt-5 font-display font-bold text-white tracking-tight text-4xl sm:text-5xl leading-[1.1] max-w-xl">
                        Higienização profissional para{" "}
                        <span className="text-brand">cada necessidade</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="text-white/60 text-base max-w-md leading-relaxed">
                        Serviços especializados de limpeza e higienização de estofados, executados
                        com técnica, produtos adequados e cuidado total.
                    </p>
                </Reveal>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {SERVICES.map((service, i) => {
                    const Icon = ICONS[service.icon] || Sofa;
                    const isHero = i === 0;
                    return (
                        <motion.a
                            key={service.title}
                            data-testid={`service-card-${i}`}
                            href={whatsappLink(
                                `Olá! Gostaria de um orçamento para ${service.title}.`
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                            whileHover={{ y: -6 }}
                            className={`group relative rounded-3xl border border-white/10 hover:border-brand bg-navy-800 overflow-hidden p-7 flex flex-col justify-between transition-colors duration-300 ${gridClass(i)}`}
                        >
                            {isHero && (
                                <>
                                    <img
                                        src={IMAGES.upholstery}
                                        alt="Higienização profissional de estofados"
                                        className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-40 transition-opacity duration-500"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-navy/40" aria-hidden="true" />
                                </>
                            )}
                            <div className="relative z-10 flex items-start justify-between">
                                <span className="w-12 h-12 rounded-xl bg-brand/15 border border-brand/30 flex items-center justify-center transition-colors duration-300 group-hover:bg-brand">
                                    <Icon className="w-6 h-6 text-brand transition-colors duration-300 group-hover:text-white" strokeWidth={1.8} />
                                </span>
                                <ArrowUpRight className="w-5 h-5 text-white/30 transition-all duration-300 group-hover:text-brand group-hover:translate-x-1 group-hover:-translate-y-1" />
                            </div>
                            <div className="relative z-10 mt-10">
                                <h3 className="font-display font-bold text-white text-xl sm:text-2xl tracking-tight">
                                    {service.title}
                                </h3>
                                <p className="mt-3 text-sm text-white/60 leading-relaxed">
                                    {service.description}
                                </p>
                            </div>
                        </motion.a>
                    );
                })}
            </div>
        </div>
    </section>
);
